import React from "react";
import BookUploadForm from "./BookUploadForm";

const BookUpload = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <BookUploadForm />
    </div>
  );
};

export default BookUpload;